import { Popover } from 'antd'
import { EasyIcon } from 'src/components'
import { Download } from './064'

export default {
  renderRemark (text: any, record: any, ListTableContext: any) {
    return <div dangerouslySetInnerHTML={{ __html: text.replaceAll('\n', '<br />') }} />
  },
  download (ListTableContext: any, props: any) {
    const { LABEL, ICON, __RECORD__: record } = props.config
    return (
      <Popover trigger={['click']} content={<Download url={record.FS_FILE_CONTENT} />}>
        <span title={LABEL}>
          <EasyIcon type={ICON} size={16} />
          <span className='pd-l4'>{LABEL}</span>
        </span>
      </Popover>
    )
  },
}